<app-modal>
  <h1 class="h2">Export Event<ng-container *ngIf="data.calendarEventIds.length > 1">s</ng-container></h1>
  <div class="mt-0100 mb-0025">

    <ng-container>
      <div class="mt-0100 pt-0075 pb-0075 export__inset">
        <label class="export__inset-label">Export Type</label>
        <mat-radio-group [(ngModel)]="exportTypeUi">
          <mat-radio-button value="responses" [disableRipple]="true">Entity responses</mat-radio-button>
          <mat-radio-button value="events" [disableRipple]="true">Event<ng-container
              *ngIf="data.calendarEventIds.length > 1">s</ng-container></mat-radio-button>
        </mat-radio-group>
      </div>
    </ng-container>

    <div *ngIf="exportTypeUi === 'events'">
      <ng-container *ngIf="data.calendarEventIds.length > 1">
        <p>
          Export one row per {{searchTermDisplay}} event from
          <span class="nowrap">{{ data.startDate | date:'MMMM d, yyyy' }}</span>
          to
          <span class="nowrap">{{ data.endDate | date:'MMMM d, yyyy' }}</span>.
        </p>
      </ng-container>
      <ng-container *ngIf="data.calendarEventIds.length === 1">
        <p>Export one row for this event.</p>
      </ng-container>
      <p>Includes event data (name, date, etc.) and counts (RSVP, tentative, attended, no-show etc.)</p>
    </div>

    <form *ngIf="exportTypeUi === 'responses'">
      <ng-container *ngIf="data.calendarEventIds.length > 1">
        <p>
          Export one row per entity response for {{searchTermDisplay}} events from
          <span class="nowrap">{{ data.startDate | date:'MMMM d, yyyy' }}</span>
          to
          <span class="nowrap">{{ data.endDate | date:'MMMM d, yyyy' }}</span>.
        </p>
      </ng-container>
      <ng-container *ngIf="data.calendarEventIds.length === 1">
        <p>Export one row per entity response for this event.</p>
      </ng-container>
      <app-event-response-status-filter [selections]="rsvpStatuses" [includeDeclined]="true"
        (selectionChange)="rsvpStatuses = $event"></app-event-response-status-filter>

      <div *ngIf="canExportTags">
        <div class="flex flexJustify-between mt-0100 mb-0050">
          <div>
            <strong>Fields</strong>
            <span class="ml-0025" *ngIf="selectedCategories.length > 0">
              ({{selectedCategories?.length || 0}} selected)
            </span>
          </div>
          <div *ngIf="selectedCategories.length > 0">
            <a class="link link--no-line" (click)="selectedCategoriesChanged([])"
              aria-details="Clear all selected fields">
              Reset
            </a>
          </div>
        </div>

        <app-field-search-inline [campaignId]="campaignId" [targetType]="'CalendarEventType'" [withTypeSelect]="false"
          [multiple]="true" [filterOptionsFn]="buildCategoryFilterFunction()" [selectedOptions]="selectedCategories"
          (selectedOptionsChange)="selectedCategoriesChanged($event)" class="scrollable-quicksearch--wrapper d-block">
        </app-field-search-inline>

      </div>
    </form>

    <div class="row dual-btn-row with-gap mt-0100 flexJustify--end">
      <button type="button" class="btn mt-0" (click)="export()">
        Export
        <ng-container *ngIf="exportTypeUi === 'responses'">responses</ng-container>
        <ng-container *ngIf="exportTypeUi === 'events'">events</ng-container>
      </button>
    </div>
  </div>
</app-modal>
